// frontend/src/layouts/AuthLayout.js
import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const AuthLayout = () => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Check if we're on the login page
  const isLoginPage = location.pathname === '/login';

  return (
    <div className="min-h-screen bg-neumorph flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Only show logo header on non-login pages */}
        {!isLoginPage && (
          <div className="text-center mb-8">
            <img 
              src="/fastel-logo.png" 
              alt="Fastel" 
              className="h-16 w-auto mx-auto mb-3"
            />
            <h1 className="text-2xl font-bold bg-gradient-to-r from-primary-700 to-primary-500 bg-clip-text text-transparent">
              Fastel
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              VTU & Bill Payments
            </p>
          </div>
        )}

        {/* Auth Form Card - add margin-top when no logo */}
        <div className={`card p-6 border border-primary-100/30 ${!isLoginPage ? '' : 'mt-0'}`}>
          <Outlet />
        </div>

        {/* Simple Footer (optional) */}
        <p className="text-center text-xs text-gray-400 mt-6">
          © 2026 Fastel. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;